import { render, staticRenderFns } from "./tagSubscribeContent.vue?vue&type=template&id=013d1dac&scoped=true"
import script from "./tagSubscribeContent.vue?vue&type=script&lang=js"
export * from "./tagSubscribeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013d1dac",
  null
  
)

export default component.exports